import { Component, ComponentDefinition } from "components/components/Component";
import template from "./linkTree.hbs";
import "./linkTree.scss";

export class LinkTree implements Component {
    public componentType: "linkTree";
    public id;
    public definition;
    public view: HTMLElement;
    private collapsed: any;

    constructor(definition: LinkTreeDefinition) {
        this.definition = definition;
        this.definition.collapsed = true;
    }
    public render(): Element {
        const d = document.createElement("div");
        d.innerHTML = template(Object.assign(this.definition, { _noTranslate: !this.definition.translate }));

        this.view = d.firstElementChild as HTMLElement;
        this.view.querySelector(".c-link-tree__title")?.addEventListener("click", this.toggle);

        return this.view;
    }

    private toggle = () => {
        if (this.collapsed) {
            this.expand();
        } else {
            this.collapse();
        }
    }

    public collapse() {
        this.collapsed = true;
        this.view.querySelector(".c-link-tree__title")?.classList.add("c-link-tree__title__up");
        (this.view.querySelectorAll("ul>li>ul")).forEach((e) => (e as HTMLElement).style.display = "none");
    }

    private expand() {
        this.collapsed = false;
        this.view.querySelector(".c-link-tree__title")?.classList.remove("c-link-tree__title__up");
        (this.view.querySelectorAll("ul>li>ul")).forEach((e) => (e as HTMLElement).style.display = "inline-block");
    }

    public postRender = () => {
        if (this.definition.collapsed) {
            this.collapse();
        }
    }

    public static getUniqueLink(definition: LinkTreeDefinition) {
        return this.getUniqueLinkInBranch(definition.tree);
    }
    private static getUniqueLinkInBranch(node: LinkTreeNode) {
        if (node.url != null) {
            return node.url;
        }
        if (node.children.length === 1) {
            return this.getUniqueLinkInBranch(node.children[0]);
        }
        return null;
    }
}

export interface LinkTreeDefinition extends ComponentDefinition {
    tree: LinkTreeNode;
}

export interface LinkTreeNode {
    text: string;
    url?: string;
    translate: boolean;
    children?: LinkTreeNode[];
}

